import { EventEmitterFactory } from '@propertyfinder/pf-frontend-common/src/module/event/emitter.factory';
import { BrowserStorageSessionService } from '@propertyfinder/pf-frontend-common/src/service/browser-storage-session/service';

import { PropertyStoreService } from 'common/service/property-store/service';
import { StatsTealiumProviderService } from 'common/service/stats-tealium-provider/service';

import { PropertyListStatsTealiumImpressionsStore } from './impressions.store';

export function PropertyListStatsTealiumImpressionsFactory(): PropertyListStatsTealiumImpressionsStore {
  return new PropertyListStatsTealiumImpressionsStore(
    EventEmitterFactory(),
    BrowserStorageSessionService(),
    PropertyStoreService(),
    StatsTealiumProviderService()
  );
}
